/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowARightIcon64Regular = forwardRef('ArrowARightIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M36.44 12.06a1.5 1.5 0 0 1 2.12-2.12l16.758 16.757a7.5 7.5 0 0 1 0 10.606L38.561 54.061a1.5 1.5 0 0 1-2.122-2.122l16.758-16.757a4.482 4.482 0 0 0 1.061-1.682H8a1.5 1.5 0 1 1 0-3h46.258a4.483 4.483 0 0 0-1.061-1.682L36.439 12.061Z" })));
});
